export const IconClose = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8044_5370)">
<path d="M0.683594 0.683838L19.3161 19.3163" stroke="#4E8CB7" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.6325 1L1 19.6325" stroke="#4E8CB7" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_8044_5370">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
`